import { CloseButton, Group, Table } from '@mantine/core';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import { useState } from 'react';
import { TableRowCollapsible } from '../../../components/TableRowCollapsible';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';
import { formatToCurrency } from '../../../util/formatting';
import type { GroupTotalDto } from '../types/GroupDtos';
import { DepartmentTable } from './DepartmentTable';
import { KeyedRow } from '../../../components/KeyedRow';

export function GroupTotalRow({ group }: { group: GroupTotalDto }) {
	const [departmentOpen, setDepartmentOpen] = useState(false);

	return (
		<>
			<KeyedRow
				key={group.id}
				id={`${group.id}`}
				onClick={() => setDepartmentOpen(!departmentOpen)}
			>
				<Table.Td>{group.name}</Table.Td>
				<Table.Td>{group.qtySold}</Table.Td>
				<Table.Td>{formatToCurrency(group.netSales)}</Table.Td>
				<Table.Td>{formatToCurrency(group.grossSales)}</Table.Td>
				<Table.Td>{formatToCurrency(group.vat)}</Table.Td>
				<Table.Td>{formatToCurrency(group.discount)}</Table.Td>
				<Table.Td w={'6vw'}>
					<Group justify={'center'}>
						<CloseButton
							c={'medepos.1'}
							icon={
								!departmentOpen ? (
									<IconChevronDown {...defaultIconStyle} />
								) : (
									<IconChevronUp {...defaultIconStyle} />
								)
							}
							onClick={() => setDepartmentOpen(!departmentOpen)}
						/>
					</Group>
				</Table.Td>
			</KeyedRow>
			<TableRowCollapsible isOpen={departmentOpen}>
				<DepartmentTable groupId={group.id} startLoading={departmentOpen} />
			</TableRowCollapsible>
		</>
	);
}
